const header = (state = {}, action) => {
  switch (action.type) {
    case 'SET_HEADER':
      return {
        ...state, header: action.name
      }
    default:
      return state
  }
}

export default header
